
import { useSnackbar } from 'notistack';

import { useRecoilValue } from 'recoil';

import { addMonths, addDays } from 'date-fns';

import useAxios from 'library/axios'; 
import { useState } from 'react';
import {ITellerOperation, ITellerOperationSearch } from "../models/TellerOperation";
import { useTranslation  } from 'react-i18next';
import { IPagination, ITextFilterElement } from 'components/ui/BasicTextFilterForm';
import { IResult } from 'library/interface';
import { HeadCell, RowCheckedMode } from 'components/ui/EnhancedTable';

import { isNumber, toNumber } from 'lodash';

import { currentUserSessionAtom } from 'library/store';

const _ = () => {

    const axios = useAxios(); 

    //const {requestTypeBusinessApps} = useRecoilValue(currentUserSessionAtom);    

    const createTellerOperation = async (tellerOperation: ITellerOperation)  =>       
        await (await axios.post('/api/finance/tellerOperation/create', tellerOperation)).data;       
        
    const updateTellerOperation = async (tellerOperation: ITellerOperation)  =>       
        await (await axios.post('/api/finance/tellerOperation/update', tellerOperation)).data; 
    
    const getTellerOperation = async (id  : number )  => {
      const {data} = (await axios.get(`/api/finance/tellerOperation/get-tellerOperation/${id}`));
      return await data;
    }
   

    const getTellerOperations = async (criteria: ITellerOperationSearch, pagination?: IPagination) : Promise<ITellerOperation[]> => {
      
      const {startDate, endDate, isMyOperations , customerName, reference, bearer} = criteria;

      const sStartDate = encodeURIComponent(startDate.toISOString());
      const sEndDate = encodeURIComponent(endDate.toISOString());

      const pageSize = pagination?.pageSize ?? 50;
      const pageNumber = pagination?.pageNumber ?? 1;

      const {data} = (await axios.get(`/api/finance/tellerOperation/get-tellerOperations?sStartDate=${sStartDate}` +
        `&sEndDate=${sEndDate}&isMyOperations=${isMyOperations}&customerName=${customerName}&reference=${reference}&bearer=${bearer}&pageSize=${pageSize}&pageNumber=${pageNumber}`));
      return await data;
    }

    const getTellerOperationsByBilling = async (billingId: number) : Promise<ITellerOperation[]> => {
      
      const {data} = (await axios.get(`/api/finance/tellerOperation/get-tellerOperations-by-billing?billingId=${billingId}`));
      return await data;
    }
      
    return {    
      createTellerOperation,
      updateTellerOperation,
      getTellerOperation,
      getTellerOperations,

      getTellerOperationsByBilling
     
    } 
}

export default _;

export interface IFilterTellerOperationOption {
  rowCheckedMode: RowCheckedMode,
  stateSelected?: [number[], React.Dispatch<React.SetStateAction<number[]>>],
  stateFiltered?: [ITellerOperation[], React.Dispatch<React.SetStateAction<ITellerOperation[]>>],
}

const defaultFilterProductOption: IFilterTellerOperationOption = {
  rowCheckedMode: 'single'
  //stateSelected: navigate
}


export const useBasicFilterTellerOperation = (  onRowDoubleClick: (event: React.MouseEvent<unknown>, row: ITellerOperation) => void,
                                            filterOption?: IFilterTellerOperationOption  ) => {

  const { getTellerOperations } = _();

  const { t, i18n } = useTranslation();   

  const {language: lg, applicationSetup } = useRecoilValue(currentUserSessionAtom);

  const {rowCheckedMode, stateSelected, stateFiltered} = filterOption || defaultFilterProductOption;

  const [headTellerOperationCells, setHeadTellerOperationCells]  = useState<HeadCell<ITellerOperation>[]>([
    {id:'id', label : t('Id'),  display: true, type: 'numeric', width: 5  },
    
    {id:'customerNameFR', label : t('Customer'),  display: lg.includes('fr'), type: 'string', width: 40, },
    {id:'customerNameEN', label : t('Customer'),  display: lg.includes('en'), type: 'string', width: 40, },

    {id:'reference', label : t('Reference'),  display: true, type: 'string',width: 20 },
    {id:'operationNumber', label : t('Number'),  display: true, type: 'string', width: 15},
    
    {id:'amount', label : t('Amount'),  display: true, type: 'numeric', width: 10},
    {id:'operationDate', label : t('Date'),  display: true, type: 'date', width: 10 },
    
    // {id:'schoolYearName', label : t('School year'),  display: true, type: 'string', },
    // {id:'schoolYearClassName', label : t('Class'),  display: true, type: 'string', },

  ]); 
  const [filterElements,] = useState<ITextFilterElement[]>( [
         
    {name: 'startDate', text: t('Start date'), dataType: 'date' ,  value: '', dateValue: new Date()},
    {name: 'endDate', text: t('End date'), dataType: 'date'  , value: '', dateValue: new Date()},

    {name: 'isMyOperations', text: t('My Operations'), value: '', dataType: 'boolean', boolValue: false}, 
    {name: 'customerName', text: t('Customer'), value: ''}, 

    {name: 'reference', text: t('Reference'), value: ''},
    {name: 'bearer', text: t('Bearer'), value: ''},  
      
    ]);    

  const [filteredTellerOperations, ] = useState<ITellerOperation[]>([]); 

  const onFilterButtonClick = async (filterElements: ITextFilterElement[], pagination?: IPagination) : Promise<ITellerOperation[]> => {
    
    const startDate = filterElements.find( elt => elt.name === 'startDate')?.dateValue || new Date();
    const endDate = filterElements.find( elt => elt.name === 'endDate')?.dateValue || new Date();

    const customerName = filterElements.find( elt => elt.name === 'customerName')?.value || '';
    const isMyOperations = filterElements.find( elt => elt.name === 'isMyOperations')?.boolValue || false;

    const reference = filterElements.find( elt => elt.name === 'reference')?.value || '';
    const bearer = filterElements.find( elt => elt.name === 'bearer')?.value || '';
       
    const arr = await getTellerOperations( { startDate,endDate,customerName,isMyOperations,reference,bearer }, pagination );
    
    return arr;
  }

  const objKey: keyof ITellerOperation = 'id';

  return {
    title: t('Teller operation'), headCells: headTellerOperationCells, objKey,
    filterElements, rows: filteredTellerOperations, 
    onFilterButtonClick, onRowDoubleClick, rowCheckedMode, stateSelected, stateFiltered
  }
}
